<template>
  <el-container>
    <el-header>
      <el-form :inline="true">
        <el-form-item label="客户：">
          <el-input v-model="queryParam.SearchValue" placeholder="请输入客户" style="width: 110px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="queryParam.QQType" style="width: 100px">
            <el-option value="QQ" label="QQ"></el-option>
            <el-option value="BotQQ" label="接单QQ"></el-option>
          </el-select>
          <el-input v-model="queryParam.QQValue" placeholder="请输入QQ号" style="width: 110px"></el-input>
        </el-form-item>
        <el-form-item label="货号：">
          <el-input v-model="queryParam.ItemNo" placeholder="请输入货号" style="width: 100px"></el-input>
        </el-form-item>
        <el-form-item label="等级：">
          <el-select v-model="queryParam.LevelCode" placeholder="请选择等级" style="width: 85px" clearable>
            <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="handleQuery">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item class="action-button">
          <el-button type="primary" plain icon="el-icon-plus" @click="handleAdd">新增</el-button>
          <el-button type="danger" plain icon="el-icon-delete" @click="handleDelete(null)">删除</el-button>
          <el-button plain icon="el-icon-download" @click="handleExport" :loading="exportLoading"> 导出 </el-button>
          <el-button plain icon="el-icon-s-flag" @click="handleOpenLevelDialog">开启等级</el-button>
          <el-button plain icon="el-icon-setting" @click="handleBatchLevelDialog">批量设置等级</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main>
      <grid-table
        ref="gridTable"
        :tableConfig="tableConfig"
        @selectionChange="handleSelectionChange"
        :showLastEmptyColumn="false"
        :showIndexColumn="false"
        :showCheckboxColumn="true"
      >
        <template slot="Name" slot-scope="{ params }">
          {{ params.row['Name'] }}
        </template>
        <template slot="ParentPurchaserName" slot-scope="{ params }">
          <div v-if="params.row['PurchaserID'] != params.row['ParentPurchaserID']">
            {{ params.row['ParentPurchaserName']
            }}<font v-if="params.row['BindPermissions'] > 0">（{{ params.row['BindPermissions'] == 2 ? '价格' : '接单' }}）</font>
          </div>
        </template>
        <!-- 等级列 - 新增这个插槽 -->
        <template slot="LevelCode" slot-scope="{ params }">
          {{ getLevelName(params.row.LevelCode) }}
        </template>

        <template slot="OP" slot-scope="{ params }">
          <el-button type="primary" plain size="mini" @click.stop="handleBindUserList(params.row)">客户关系映射</el-button>
          <el-button plain size="mini" @click.stop="handleSettlePriceEdit(params.row)" :disabled="params.row.BindPermissions == 1"
            >客户价设置</el-button
          >

          <el-popover
            placement="top"
            popper-class="errPopper"
            style="margin-left: 10px; min-width: 0px !important"
            trigger="click"
            title=""
          >
            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 66px; gap: 10px">
              <el-link :underline="false" @click.stop="handleEdit(params.row)" :disabled="params.row.BindPermissions == 1">编辑</el-link>
              <el-link :underline="false" @click.stop="handleDelete(params.row)" :disabled="params.row.BindPermissions == 1">删除</el-link>
            </div>
            <el-button plain size="mini" slot="reference" :disabled="params.row.BindPermissions == 1"
              >更多 <i class="el-icon-arrow-down"></i
            ></el-button>
          </el-popover>
        </template>
      </grid-table>
    </el-main>
    <customer-edit ref="editDialog" v-if="dialogVisible" @handleQuery="handleQuery"></customer-edit>
    <level-dialog ref="levelDialog" @success="handleQuery" @handleSaveLevels="updateLevel" />
    <batch-save-level ref="batchSaveLevelDialog" v-if="batchSaveLevelDialogVisible" @handleBatchSaveLevels="handleBatchSaveLevels" />
    <settle-price-list ref="settlePriceListRef" @priceDiscountChange="handlePriceDiscountChange" />
    <bind-user-list ref="bindUserListRef" @handleQuery="handleQuery" />
    <purchaser-mapping ref="purchaserMappingDlg" @handleSearch="handleQuery" />
  </el-container>
</template>

<script>
import { submit, exportFile } from '@/api/base'
import dayjs from 'dayjs'
import CustomerEdit from '@/views/stall/purchaser/components/Edit.vue'
import LevelDialog from '@/views/stall/purchaser/components/LevelDialog.vue'
import batchSaveLevel from '@/views/stall/purchaser/components/BatchSaveLevel.vue'
import SettlePriceList from '@/views/stall/purchaser/components/SettlePriceList.vue'
import BindUserList from '@/views/stall/purchaser/components/BindUserList.vue'
import PurchaserMapping from '@/views/stall/trade/components/PurchaserMapping.vue'

export default {
  name: 'customerList',
  components: {
    CustomerEdit,
    LevelDialog,
    batchSaveLevel,
    SettlePriceList,
    BindUserList,
    PurchaserMapping,
  },
  data() {
    return {
      tableConfig: {
        url: '/api/stall/getPurchaserPageList',
        rowKey: 'ID',
        columns: [
          {
            label: '客户',
            prop: 'Name',
            type: 'custom-operation',
          },
          {
            label: '映射主客户（类型）',
            prop: 'ParentPurchaserName',
            type: 'custom-operation',
          },
          {
            label: '等级',
            prop: 'LevelCode',
            type: 'custom-operation',
          },
          {
            label: '昵称',
            prop: 'Nick',
            type: 'text',
          },
          {
            label: 'QQ',
            prop: 'QQ',
            type: 'text',
          },
          {
            label: '接单QQ',
            prop: 'BotQQ',
            type: 'text',
          },
          {
            label: '仓库',
            prop: 'WName',
            props: ['WName'],
            type: 'text',
            isHidden: !this.$store.state.routes.systemSetting.MultiWarehouse,
          },
          {
            label: '操作',
            prop: 'OP',
            type: 'custom-operation',
            width: '310px',
          },
        ],
      },
      queryParam: {
        SearchValue: '',
        QQType: 'BotQQ',
        QQValue: '',
        ItemNo: '',
        LevelCode: '',
      },
      levelOptions: [],
      levelMap: {}, // 新增：对象格式 { level1: '一级2', level2: '2122' }
      selectRows: [],
      dialogVisible: false,
      editFormConfig: {},
      exportLoading: false,
      batchSaveLevelDialogVisible: false,
    }
  },
  mounted() {
    let _this = this
    this.$nextTick(() => {
      _this.handleQuery()
      _this.loadLevelOptions()
    })
  },
  methods: {
    handleQuery() {
      this.$refs.gridTable.searchParam = { ...this.queryParam }
      this.$refs.gridTable.fetchData(false, null, this.$refs.gridTable.searchParam)
    },
    async loadLevelOptions() {
      const res = await submit('/api/common/getCustomerParameter?key=PurchaserLevels')
      if (res.success && res.data) {
        let levelsData = {}
        try {
          levelsData = JSON.parse(res.data)
        } catch {
          levelsData = {}
        }
        this.levelOptions = Object.keys(levelsData).map(key => ({
          value: key,
          label: levelsData[key] || key,
        }))
        // 保存为对象（用于快速查找）
        this.levelMap = levelsData
      }
    },
    handleSelectionChange(selection) {
      this.selectRows = selection
    },
    reset() {
      this.queryParam.ItemNo = ''
      this.queryParam.SearchValue = ''
      this.queryParam.QQValue = ''
      this.queryParam.LevelCode = ''
      this.handleQuery()
    },
    handleAdd() {
      this.dialogVisible = true
      let _this = this
      this.$nextTick(() => {
        _this.$refs.editDialog.init('新增', null, _this.$store.state.routes.systemSetting)
      })
    },
    async handleEdit(row) {
      try {
        const res = await submit('/api/stall/GetPurchaserInfo', {
          ID: row.ID,
          PurchaserID: row.PurchaserID,
        })
        if (res.success) {
          this.dialogVisible = true
          this.$nextTick(() => {
            this.$refs.editDialog.init('编辑', res.data, this.$store.state.routes.systemSetting)
          })
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log('获取数据失败', error)
      }
    },
    handleSettlePriceEdit(row) {
      this.$refs.settlePriceListRef.show(row)
    },
    handleBindUserList(row) {
      if (!row.ParentPurchaserID) {
        this.$refs.purchaserMappingDlg.show(row)
      } else {
        this.$refs.bindUserListRef.show(row)
      }
    },
    handleDelete(row) {
      var idList = []
      var confirmText = ''
      if (row == null) {
        if (!this.selectRows || this.selectRows.length == 0) {
          this.$baseMessage(`请选择要删除的数据`, 'error')
          return false
        }
        this.selectRows.forEach(t => {
          idList.push(t['ID'])
        })
        confirmText = '确定要删除选中的 ' + this.selectRows.length + '个客户？'
      } else {
        idList.push(row['ID'])
        confirmText = '确定要删除客户【' + row['Name'] + '】？'
      }
      let _this = this
      this.$confirm(confirmText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '正在提交中...'
            const rsp = await submit('/api/stall/deletePurchaser', {
              IDs: idList.join(),
            }).catch(error => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '确认'
              done()
            })
            instance.confirmButtonLoading = false
            _this.$message({
              type: rsp.success ? 'success' : 'error',
              message: rsp.msg,
            })
            _this.handleQuery()
            done()
          } else {
            done()
          }
        },
      })
    },
    async handleExport() {
      this.exportLoading = true
      const today = dayjs().format('YYYYMMDDHHmmss')
      var param = this.queryParam
      const { data } = await exportFile('/api/stall/exportPurchaserList', param).finally(() => {
        this.exportLoading = false
      })
      const blob = new Blob([data.Blob], { type: 'application/vnd.ms-excel' })
      var a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = '客户_' + today + '.xls'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    handleOpenLevelDialog() {
      this.$nextTick(() => {
        this.$refs.levelDialog.open()
      })
    },
    handleBatchLevelDialog() {
      if (this.selectRows.length === 0) {
        this.$message.error('请选择要设置等级的客户')
        return
      }
      this.batchSaveLevelDialogVisible = true
      this.$nextTick(() => {
        this.$refs.batchSaveLevelDialog.open(this.selectRows)
      })
    },
    async handleBatchSaveLevels(batchParam) {
      try {
        const res = await submit('/api/stall/batchUpdatePurchasersLevel', {
          ids: batchParam.ids,
          levelCode: batchParam.levelCode,
          levelName: batchParam.levelName,
        })
        if (res.success) {
          this.$message.success('设置成功')
          if (this.$refs.gridTable && this.$refs.gridTable.$refs.gridTable) {
            this.$refs.gridTable.$refs.gridTable.clearSelection()
          }
          this.selectRows = []
          this.handleQuery()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log('设置失败', error)
      }
    },
    handlePriceDiscountChange(purchaserID, priceDiscount) {
      for (let row of this.$refs.gridTable.tableData) {
        if (row.PurchaserID == purchaserID) {
          row.PriceDiscount = priceDiscount
          row.Config.PriceDiscount = priceDiscount
          break
        }
      }
    },
    // 根据 LevelCode 获取显示名称（只用于列表展示）
    getLevelName(levelCode) {
      if (!levelCode) return ''
      return this.levelMap[levelCode] || ''
    },
    // 更新客户等级设置
    async updateLevel(data) {
      // console.log('接收到的数据:', data);
      // data.levels - 选中的等级数组
      // data.levelNames - 自定义名称映射

      // 保存等级配置
      const res = await submit('/api/common/updateCustomerParameter', {
        key: 'PurchaserLevels',
        value: JSON.stringify(data.levelNames),
      })

      if (res.success) {
        this.$message.success('保存成功')
        this.loadLevelOptions() // 重新加载等级选项
        this.handleQuery() // 刷新列表
      }
    },
  },
}
</script>
/* 重要：不要加 scoped */
<style lang="scss">
/* 选择器必须包含 .el-popover 和自定义类名，确保权重足够 */
.el-popover.errPopper {
  min-width: 80px !important; /* 强制覆盖默认 150px */
  width: 80px !important; /* 设定具体宽度 */
  padding: 0 !important; /* 去除默认内边距，否则内容会被挤压 */
  box-sizing: border-box; /* 确保宽度计算包含 padding */
}
</style>

<style lang="scss" scoped>
::v-deep {
  .el-header {
    height: 54px !important;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 10px 0 !important;

    .el-form {
      .el-form-item {
        margin-bottom: 5px !important;

        &.action-button {
          position: absolute;
          right: 0;
        }
      }
    }

    .el-select {
      width: 100px;
      margin-right: 5px;
    }

    .el-form-item__label {
      padding-right: 0;
    }
  }

  .el-main {
    border-top: 0px !important;
  }

  .el-popover {
    width: 80px !important;
    min-width: 0 !important;
    text-align: center;
  }
}
</style>
